import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faHome,
    faGripHorizontal,
    faVideo,
    faBook,
    faBookOpen,
    faImages,
    faCompress,
    faExpand,
    faPlusCircle,
    faTrashAlt,
    faFileImport,
    faFileExport,
    faDownload,
    faTv,
    faArrowUp,
    faStop,
    faEdit,
    faGrin,
    faSave,
    faFilter,
    faTimes,
    faArchive,
    faSearch,
    faCopy,
    faIndustry,
    faEye,
    faEyeSlash,
    faInbox,
    faCogs,
    faUndoAlt,
    faStore,
    faExternalLinkAlt,
    faGlobe,
    faGripVertical,
    faBan,
    faAd,
    faFunnelDollar,
    faChartPie,
    faKey,
    faSignInAlt,
    faDoorOpen,
    faAt,
    faExchangeAlt,
    faUpload,
    faExclamationCircle,
    faChartLine,
    faChartArea,
    faLock,
    faLockOpen,
    faPlayCircle,
    faUser,
    faUserSecret,
    faUserGroup,
    faHandsHelping,
    faBoxOpen,
    faFire,
    faInfo,
    faPercent,
    faClone,
    faPhotoVideo,
    faAsterisk,
    faEllipsisV,
    faTags,
    faLayerGroup,
    faMoneyBillWave,
    faListOl,
    faSquareCheck,
    faChevronDown,
    faCheck,
    faHandshake,
    faSortAmountDown,
    faBars,
    faRss,
    faCreditCard
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faHome,
    faGripHorizontal,
    faVideo,
    faBook,
    faBookOpen,
    faImages,
    faCompress,
    faExpand,
    faPlusCircle,
    faTrashAlt,
    faFileImport,
    faFileExport,
    faDownload,
    faTv,
    faArrowUp,
    faStop,
    faEdit,
    faGrin,
    faSave,
    faFilter,
    faTimes,
    faArchive,
    faSearch,
    faCopy,
    faIndustry,
    faEye,
    faEyeSlash,
    faInbox,
    faCogs,
    faUndoAlt,
    faStore,
    faExternalLinkAlt,
    faGlobe,
    faGripVertical,
    faBan,
    faAd,
    faFunnelDollar,
    faChartPie,
    faKey,
    faSignInAlt,
    faDoorOpen,
    faAt,
    faExchangeAlt,
    faUpload,
    faExclamationCircle,
    faChartLine,
    faChartArea,
    faLock,
    faLockOpen,
    faPlayCircle,
    faUser,
    faUserSecret,
    faUserGroup,
    faHandsHelping,
    faBoxOpen,
    faFire,
    faInfo,
    faPercent,
    faClone,
    faPhotoVideo,
    faAsterisk,
    faEllipsisV,
    faTags,
    faLayerGroup,
    faMoneyBillWave,
    faListOl,
    faSquareCheck,
    faChevronDown,
    faCheck,
    faHandshake,
    faSortAmountDown,
    faBars,
    faRss,
    faCreditCard
);
